<template>
  <audio v-if="safeSrc" :key="safeSrc" :src="safeSrc" controls preload="none" />
</template>
<script>
export default {
  name: 'DigitalHumanAudioPreview',
  props: { src: { type: String, default: '' } },
  computed: {
    // 使用原生播放器，只有用户主动点击才拉取试听，切换声音时销毁上一段音频。
    safeSrc() {
      try { const url = new URL(this.src); return url.protocol === 'https:' && !url.username && !url.password ? this.src : '' } catch (_) { return '' }
    }
  }
}
</script>
